import { useEffect } from "react";

import { Box } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";
import useEntity from "../../hooks/useEntity";

import Input from "../elements/Input";
import Switch from "../elements/Switch";
import EditorToolbar from "./EditorToolbar";

const RetailerEditor = ({ retailerId, onSave }) => {
  const { getLabel } = useLocalization();
  const {
    setEntity,
    emptyObject,
    entityData,
    clearEntityData,
    getEntityData,
    validateEntityData,
    updateField,
    message,
    isSuccessful,
    getFieldMessage,
    saved,
  } = useEntity();

  useEffect(() => {
    setEntity("Retailer");
  }, []);

  useEffect(() => {
    if (!retailerId) {
      clearEntityData();
    } else getEntityData(retailerId);
  }, [emptyObject]);

  const handleSave = async () => {
    validateEntityData();
  };

  useEffect(() => {
    if (!saved) return;
    onSave();
  }, [saved]);

  if (!entityData) return;

  return (
    <Box
      width="100%"
      height="100%"
    >
      <EditorToolbar
        onSave={handleSave}
        message={message}
      />
      <Box
        width="calc(100% - 2rem)"
        height="calc(100% - 2rem - 30px)"
        padding="1rem"
        display="flex"
        flexDirection="column"
        gap={1}
        overflow="auto"
      >
        <Input
          id="retailerName"
          label={getLabel("name")}
          value={entityData.name}
          onChange={(newValue) => updateField("name", newValue)}
          required
          fullwidth
          {...getFieldMessage("name")}
        />
        <Input
          id="retailerNameFr"
          label={getLabel("name_fr")}
          value={entityData.name_fr}
          onChange={(newValue) => updateField("name_fr", newValue)}
          fullwidth
          {...getFieldMessage("name_fr")}
        />
        <Switch
          label={getLabel("active")}
          value={!retailerId ? true : Boolean(entityData.isActive)}
          onChange={(newValue) => updateField("isActive", Boolean(newValue))}
        />
      </Box>
    </Box>
  );
};

export default RetailerEditor;
